<template><zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page class="table-hardcode" content-class="pa0" title="Daftar Bayaran">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess" v-if="form.show == true">
            <w-flex class="mt2">
                <div class="xs6 mr5">
                    <z-lookup label="Kod Akaun *" name="akaun" :url='service_utiliti+"lookup/akaun_akhir"' :sort="false" :cache="false" v-model="form.akaun_id" :validators="[validators.required]" />
                </div>
                <div class="xs6 mr5">
                    <z-lookup label="Kod Vot *" name="akaun" :url='service_utiliti+"lookup/vot"' :sort="false" :cache="false" v-model="form.vot_id" :validators="[validators.required]" />
                </div>
            </w-flex>
            <w-flex class="mt2">
                <div class="xs6 mr5">
                    <w-input  v-model="form.no_dokumen" required label="No. Dokumen "   /> 
                </div>
                <div class="xs6">
                    <w-input   v-model="form.tarikh_dokumen" required label="Tarikh Dokumen " type="date"  /> 
                </div>
            </w-flex>

            <w-flex class="mt2">
                <div class="xs6 mr5">
                    <w-input   v-model="form.tarikh_kew_terima" required label="Tarikh Terima Dokumen Di Kewangan *" type="date" :validators="[validators.required]" />
                </div>
                <div class="xs6">
                    <w-input   v-model="form.tarikh_jab_terima" required label="Tarikh Terima Dokumen Di Jabatan *" type="date" :validators="[validators.required]" /> 
                </div>
            </w-flex>
            <w-flex class="mt1">
                <div class="xs12">
                    <w-input v-model="form.keterangan" required  label="Keterangan Bayaran *" :validators="[validators.required]" /> 
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">                
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <td>Nama Penerima Bayaran *</td>
                            <td>Bank Penerima Bayaran *</td>
                            <td>No. Akaun Penerima Bayaran *</td>
                            <td>Catatan</td>
                            <td>Amaun Bayaran (RM) *</td>
                            <td> <w-icon class="mr1" @click="addItem">fal fa-plus</w-icon></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td >
                                <!-- <z-lookup  name="akaun" :url='service_utiliti+"lookup/profil"' :sort="false" :cache="false" v-model="dt.profil_id"  :validators="[validators.required]" />  -->
                                <z-input v-model="dt.profil_keterangan" name="profil_id" readonly @click="profil(index)"  :validators="[validators.required]"/>
                            </td>
                            <td>
                                <z-lookup  name="akaun" :url='service_utiliti+"lookup/bank"' :sort="false" :cache="false" v-model="dt.lkp_bank_id" :validators="[validators.required]" />
                            </td>
                            <td>
                              <w-input  v-model="dt.no_akaun" required   :validators="[validators.required]" /> 
                            </td>
                            <td>
                              <w-input  v-model="dt.catatan_bayaran"  /> 
                            </td>
                            <td>
                                <z-money v-model:originalValue="dt.amaun" v-on:keyup="cekAmaun()" validators="[validators.required]"/> 
                            </td>
                            <td><w-icon class="mr1" @click="removeItem(index)">fal fa-trash</w-icon></td>
                        </tr>
                        <tr >
                          <td colspan="4">Jumlah</td>
                          <td align="right">{{$zutil.currency(form.amaun)}}</td>
                          <td></td>
                        </tr>
                        
                    </tbody>
                </table>
              </div>

            </w-flex>

            <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />

                <w-button class="my1" bg-color="warning" dark  @click="back()" >Kembali</w-button>
                &nbsp; &nbsp;
                <template v-if="!form.lkp_bayaran_status_id">
                <w-button class="my1 error-dark1--bg"  dark  @click="reset()" >Reset</w-button>
                &nbsp; &nbsp;
              </template>
              <template v-if="(form.lkp_bayaran_status_id == 1 || form.lkp_bayaran_status_id == 5) && $zutil.can('Bayaran Penyediaan')">
                  
                  <w-button class="my1 error-dark1--bg" @click="send(0)" type="button" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                      <w-icon dark tile class="mr2"> fal fa-times mr2</w-icon> Batal
                  </w-button>
                  &nbsp;&nbsp;
                </template>
                <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                    <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                </w-button>
                <template v-if="(form.lkp_bayaran_status_id == 1 || form.lkp_bayaran_status_id == 5) && $zutil.can('Bayaran Penyediaan')">
                  

                  &nbsp;&nbsp;
                  <w-button class="my1" @click="send(1)" type="button" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                      <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Hantar
                  </w-button>
                </template>
                
                

            </w-flex>

        </w-form>

            <w-dialog
              v-model="dialogProfil.show"
              :fullscreen="dialogProfil.fullscreen"
              :width="dialogProfil.width"
              :persistent="dialogProfil.persistent"
              :persistent-no-animation="dialogProfil.persistentNoAnimation"
              title-class="primary-light1--bg white">
              <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Carian Profil
              </template>
              <div class="page-wrapper-portal">
                  <w-flex justify-center align-center>
                      <div class="xs8">
                             <w-input label="No KP | Nama (Carian minimun 2 aksara)" v-model="carian_profil.q" > </w-input>
                      </div>
                      <div class="xs4">
                            <w-button class="ml1" @click="cariProfil">Cari</w-button>
                      </div>
                  </w-flex>
                  <div class="table-profil-scrol">
                  <table class="w-table ">
                      <thead>
                      <tr>
                          <th class="w-table__header w-table__header--sortable text-left">No</th>
                          <th class="w-table__header w-table__header--sortable text-left">No KP | Nama</th>
                          <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
                      </tr>
                      </thead>
                      <tbody>
                      
                          <tr v-for="dt, index in profils">
                              <td class="w-table__cell text-left">
                                  {{(index+1)}}
                              </td>
                              <td class="w-table__cell ">
                                  {{dt.label}}
                              </td>
                              <td class="w-table__cell text-right">
                                  <w-radio class="mr2"  v-model="form.butiran[i_ind].profil_id" :return-value="dt.value" @click="pilihProfil(dt.label)"></w-radio>
                              </td>
                          </tr>
                          
                      </tbody>
                      
                  </table>
                </div>
              </div>

                <template #actions>
                <div class="spacer" />
                <w-button bg-color="grey-light5--bg" @click="dialogProfil.show = false">Tutup</w-button>
                </template>
          </w-dialog>

        
      </z-page >

  </zen-one>
</template>

<script>

import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'

export default {
  extends: ZResource,
components: {
  
},

  props: {
    id: [Array, Object, String],
  },
  setup () {
    
  },
  data() {
    return {
  
        resourceurl: this.service_pembayaran+'bayaran',
        reload: true,
        akaun_id : 3,
        crumbs: [
              { label: 'iHasil', route: '/' },
              { label: 'Bayaran', route: '/bayaran' },
              { label: 'Daftar', route: '/bayaran/daftar' },
        ],
        showCard: false,
        i_ind : null,
        carian_profil : {q: ''},
        profils : [],
        dialogProfil: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },
        
    }
},
methods: {
    back() {
      window.history.back();
    },
    addItem() {
        this.form.butiran.push( {profil_id : null, profil_keterangan : null, lkp_bank_id : null, no_akaun : null, catatan_bayaran : null, amaun : null});
    },

    removeItem(index) {
        this.form.butiran.splice(index, 1);
    },

    profil(i_ind){
      this.i_ind = i_ind
      this.dialogProfil.show = 1
    },

    cariProfil(){
      if(this.carian_profil.q.length > 1){
        this.$zcomm.post(this.service_utiliti+"lookup/profil", this.carian_profil, {})
        .then(res => {
          console.log(res)
            this.profils = res
          })
      }
    },

    pilihProfil(profil_keterangan){
      this.form.butiran[this.i_ind].profil_keterangan = profil_keterangan
    },

    cekAmaun(){
      this.form.amaun = 0;
      for (var i in this.form.butiran) {
        this.form.amaun = this.form.amaun + parseFloat(this.form.butiran[i].amaun);
      }
    },
    reset(){
      this.form = {
        show : true,
        butiran : [{profil_id : null, profil_keterangan : null, lkp_bank_id : null, no_akaun : null, catatan_bayaran : null, amaun : 0}]
      }
    },

    send(ind){
      if(ind == 1){
        if(this.form.lkp_bayaran_status_id == 1 || this.form.lkp_bayaran_status_id == 5){
          this.form.lkp_bayaran_status_id = 2
        }
      }else{
        this.form.lkp_bayaran_status_id = 6
      }
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$route('bayaran.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    },

    onSuccess(){
      if (this.form.id > 0) {
              this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
          }
          else {
              this.$zcomm.post(this.resourceurl , this.form)
                  .then(res => {
                    
                    
                    if (typeof this.onAfterAdd === "function") {
                      this.onAfterAdd()
                    }
                      this.$inertia.visit(this.$route('bayaran.semak', res.id))
                    
                  })
                  .finally(() => {
                      

                    // $('#' + this.resourceurl).modal('hide')
                  });
          }
    }
},

  mounted() {
    if(this.id == 0){
      this.form = {
        show: true,
        butiran : [{profil_id : null, lkp_bank_id : null, no_akaun : null, catatan_bayaran : null, amaun : null} ]}
      }
  },
    
}

</script>

<style>


</style>